import find from 'lodash/find';

export const getBR = ({ requirement, countryListOptions, updated, data }) => {
  const params = {
    remark: requirement.remarks ?? '',
    exportedMarket: requirement.exportedMarket ?? '',
    serviceLevel: requirement?.serviceLevel?.value ?? '',
    areas: requirement?.countryOfOrigin?.map((area) => area.id) ?? [],
    // TODO: TestingItems list
    testingItems: (requirement.testItems || [])
      .filter((obj) => typeof obj.testItem !== 'string')
      .filter(({ testItem, exportMarket }) => !!testItem && !!exportMarket)
      .map(({ testItem, testItemId, exportMarket, citationId }) => {
        const item = {
          testItemListId: testItemId,
          citationListId: citationId,
          exportMarket:
            find(countryListOptions, { value: exportMarket })?.obj?.countryCode || exportMarket,
        };
        return { ...item };
      }),
    testingAttachments: requirement?.attachments.map(
      ({ filePath, fileName, fileSize, id, documentListId }) => documentListId || id
    ),
    testingIntendedUsages: requirement?.intendedUsage?.map(({ value, label }) => value),
    testingProductProfiles: updated.map(
      ({
        id,
        name,
        itemNo,
        reportName,
        reportItemNo,
        itemNameReport,
        itemNoReport,
        testingProductInfoId,
      }) => {
        return {
          id,
          reportName: itemNameReport || reportName || name,
          reportItemNo: itemNoReport || reportItemNo || itemNo,
        };
      }
    ),
    testingLabs: ((data.isICW && data.testingLabs) || []).map(({ value, label }) => {
      return {
        labName: label,
        serviceProviderId: value,
      };
    }),
    directLabs: ((data.isDirectLab && data.directLabs) || []).map(({ value, label }) => {
      return {
        labName: label,
        laboratoryId: value,
      };
    }),
    isTicmart: data.isTicmart || false,
    isDirectLab: data.isDirectLab || false,
    isICW: data.isICW || false,
    buyerName: requirement.buyerName || '',
    companyTestItems: (requirement.testItems || [])
      .filter((obj) => typeof obj.testItem === 'string')
      .map((obj) => ({
        name: obj.testItem || '',
        citationListId: '',
        exportMarket:
          find(countryListOptions, { value: obj.exportMarket })?.obj?.countryCode ||
          obj.exportMarket,
      })),
  };
  return params;
};
